const text = {
  en: {
    h1: 'Stay in Touch With Sadhguru and Isha',
    quote:
      '“A world full of love, light and laughter, its time has come. Let us make it happen.” —Sadhguru',
    btn1: 'Learn More',
    btn2: 'Join Now',
    btn3: 'upa practice',
    btn4: 'playlist link',
    link1: '',
    link2: '',
    p1: 'Would you like to access more of Sadhguru’s wisdom and content?',
    p2: 'Are you interested in other free online Yoga and meditation sessions to enhance your emotional balance, physical wellbeing and mental health?',
    p3: 'Here are 3 ways to stay in touch, wherever you may be:',
    p4: 'Subscribe to the Sadhguru language channel on youtube, instagram or facebook.',
    p5: 'You can read the latest articles by Sadhguru, and watch the newest videos on topics ranging from spirituality, professional success, relationships, health and fitness, and living a stress-free life.',
    p6: 'In addition, you can find the playlist meditation & upa yoga to continue your practice.',
    h2: 'Receive monthly updates on Sadhguru and Isha’s activities in your region. Join below!',
    h3: 'For More Free Yoga & Meditations, Check out the Sadhguru language channel',
    h4: 'Inner Engineering Online',
    form1: 'Full Name',
    form2: 'Email Address',
    form3: 'Country'
  },
  ru: {
    h1: 'Оставайтесь на связи с Садхгуру и Ишей',
    quote:
      '“Мир, полный любви, света и смеха, - его время пришло. Давайте сделаем так, чтобы это произошло.” — Садхгуру',
    btn1: 'Узнать больше',
    btn2: 'Присоединяйтесь сейчас',
    btn3: 'Направленные медитации',
    btn4: 'Упа Йога',
    link1:
      'https://www.youtube.com/playlist?list=PLnqgRgprlYQgv-DbUXcOPoMTJ-LeMa-UP',
    link2:
      'https://www.youtube.com/playlist?list=PLnqgRgprlYQgJwgTSo8M29l0aJHQG2Efg',
    link3: 'https://www.innerengineering.com/ru/online',
    p1: 'Вы хотите получить доступ к мудрости и материалам Садхгуру?',
    p2: 'Вас интересуют другие бесплатные онлайн-сессии по йоге и медитации для улучшения эмоционального равновесия, физического и психического здоровья?',
    p3: 'Вот 3 способа оставаться на связи, где бы вы ни находились:',
    p4: `Подписывайтесь на русскоязычный канал Садхгуру на <a target='_blank' rel='noopener noreferrer' href='https://www.youtube.com/channel/UC057NSSVc2663UcpoZ0C6EQ'>youtube</a>, в <a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/sadhguru.russian/channel/?hl=en'>instagram</a> или <a target='_blank' rel='noopener noreferrer' href='https://www.facebook.com/SadhguruRussian/'>facebook</a>.`,
    p5: 'Пройдите курс "Внутренняя инженерия" с Садхгуру в вашем собственном пространстве, в вашем собственном темпе. Inner Engineering Online состоит из семи 90-минутных сессий, которые передают мощные инструменты из древней науки Йоги, способные изменить сам образ вашей жизни, поведение и опыт.',
    p6: 'Кроме того, здесь вы найдете плейлист медитаций и упа-йоги, чтобы продолжить свои занятия. ',
    p7: 'Пройдите курс "Внутренняя инженерия" с Садхгуру в вашем собственном пространстве, в вашем собственном темпе. Inner Engineering Online состоит из семи 90-минутных сессий, которые передают мощные инструменты из древней науки Йоги, способные изменить сам образ вашей жизни, поведение и опыт.',
    h2: 'Получайте ежемесячные обновления о деятельности Садхгуру и Иши в вашем регионе. Присоединяйтесь ниже!',
    h3: 'Дополнительные бесплатные практики йоги и медитации ищите на русскоязычном канале Садхгуру',
    h4: 'Внутренняя инженерия онлайн',
    form1: 'Полное имя',
    form2: 'Адрес электронной почты',
    form3: 'Страна',
    thanks1: 'Спасибо',
    thanks2:
      'Мы отправим вам подтверждение по электронной почте в ближайшее время'
  },
  it: {
    h1: 'Rimani in contatto con Sadhguru e Isha',
    quote:
      '“Un mondo pieno di amore, luce e risate, il suo tempo è arrivato. Facciamo in modo che accada.” —Sadhguru',
    btn1: 'Per saperne di più',
    btn2: 'Join Now',
    btn3: 'Meditazioni',
    btn4: 'Upa Yoga',
    link1:
      'https://www.youtube.com/playlist?list=PLK_wOuD3V3DPP6ugjWfmPaSGLs9ptzI7O',
    link2:
      'https://www.youtube.com/playlist?list=PLK_wOuD3V3DPuh4_Ghkefp-f0M_zVc0pF',
    link3: 'https://www.innerengineering.com/it/online',
    p1: 'Vuoi accedere a più saggezza e contenuti di Sadhguru?',
    p2: 'Sei interessato ad altre sessioni gratuite di Yoga e meditazione online per migliorare il tuo equilibrio emotivo, il benessere fisico e la salute mentale?',
    p3: 'Ecco 2 modi per rimanere in contatto, ovunque tu sia:',
    p4: `Iscriviti al canale Sadhguru Italiano su <a target='_blank' rel='noopener noreferrer' href='https://www.youtube.com/channel/UCVoo2xW_PFFpdkh9vjexLTg'>youtube</a>, <a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/sadhguru/?hl=en'>instagram</a> o <a target='_blank' rel='noopener noreferrer' href='https://www.facebook.com/SadhguruItaliano/'>facebook</a>.`,
    p5: "Sperimenta l'Ingegneria Interiore con Sadhguru nel tuo spazio, al tuo ritmo. L'Inner Engineering Online è composto da sette sessioni di 90 minuti che impartiscono potenti strumenti dall'antica scienza dello Yoga, con il potenziale di trasformare il tuo modo di vivere, condurre e sperimentare la tua vita.",
    p6: 'Inoltre, puoi trovare la playlist Meditazioni e Upa Yoga per continuare le tue pratiche.',
    p7: "Sperimenta l'Ingegneria Interiore con Sadhguru nel tuo spazio, al tuo ritmo. L'Inner Engineering Online è composto da sette sessioni di 90 minuti che impartiscono potenti strumenti dall'antica scienza dello Yoga, con il potenziale di trasformare il tuo modo di vivere, condurre e sperimentare la tua vita.",
    h2: 'Receive monthly updates on Sadhguru and Isha’s activities in your region. Join below!',
    h3: "Per ulteriori video gratuiti di Yoga e Meditazione, dai un'occhiata al canale Sadhguru Italiano",
    h4: 'Ingegneria Interiore Online',
    form1: 'Full Name',
    form2: 'Email Address',
    form3: 'Country',
    thanks1: '',
    thanks2: ''
  },
  es: {
    h1: 'Mantente en contacto con Sadhguru e Isha',
    quote:
      '“Un mundo lleno de amor, luz y risas, ha llegado su hora. Hagámoslo realidad.” —Sadhguru',
    btn1: 'Más información',
    btn2: 'Join Now',
    btn3: 'Yoga y meditación',
    btn4: 'UPA Yoga',
    link1:
      'https://www.youtube.com/playlist?list=PLe_fEYdAPCC-NxWDoM4Vd1DQMakK0kuZf',
    link2:
      'https://www.youtube.com/playlist?list=PLe_fEYdAPCC8eX_ip5m0C64exc6GERVPB',
    link3: 'https://www.innerengineering.com/es/online',
    p1: '¿Te gustaría acceder a más sabiduría y contenido de Sadhguru?',
    p2: '¿Estás interesado en otras sesiones gratuitas de yoga y meditación online para mejorar tu equilibrio emocional, tu bienestar físico y tu salud mental?',
    p3: 'Aquí tienes 2 formas de estar en contacto, estés donde estés:',
    p4: `Suscríbete al canal de Sadhguru Español en <a target='_blank' rel='noopener noreferrer' href='https://www.youtube.com/channel/UCJoOIj9Yu71wklP3EFzL8-A'>youtube</a>, <a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/sadhguruespanol/?hl=en'>instagram</a> o <a target='_blank' rel='noopener noreferrer' href='https://www.facebook.com/SadhguruEspanol/'>facebook</a>.`,
    p5: 'Experimenta la Ingeniería Interior con Sadhguru en tu propio espacio, a tu propio ritmo. Ingeniería Interior en línea se compone de siete sesiones de 90 minutos que imparten poderosas herramientas de la antigua ciencia del Yoga, con el potencial de transformar la forma en que vives, conduces y experimentas tu vida.',
    p6: 'Además, puedes encontrar la lista de reproducción de meditación y upa yoga para continuar con tu práctica.',
    p7: 'Experimenta la Ingeniería Interior con Sadhguru en tu propio espacio, a tu propio ritmo. Ingeniería Interior en línea se compone de siete sesiones de 90 minutos que imparten poderosas herramientas de la antigua ciencia del Yoga, con el potencial de transformar la forma en que vives, conduces y experimentas tu vida.',
    h2: 'Receive monthly updates on Sadhguru and Isha’s activities in your region. Join below!',
    h3: 'Para obtener más yoga y meditaciones gratis, visita el canal de Sadhguru Español',
    h4: 'Ingeniería Interior en Línea',
    form1: 'Full Name',
    form2: 'Email Address',
    form3: 'Country',
    thanks1: '',
    thanks2: ''
  },
  de: {
    h1: 'Bleib in Kontakt mit Sadhguru und Isha',
    quote:
      '“Eine Welt voller Liebe, Licht und Lachen, ihre Zeit ist gekommen. Lasst es uns wahr machen.” —Sadhguru',
    btn1: 'Mehr erfahren',
    btn2: 'Sich einschreiben',
    btn3: 'Geführte Meditationen',
    btn4: 'Upa Yoga',
    link1:
      'https://youtube.com/playlist?list=PLIP9FB14XTIReHefrZyDSQ2AJ8AzawjLQ',
    link2:
      'https://youtube.com/playlist?list=PLIP9FB14XTIRNrRRPreUeWG2s40h_Ltim',
    link3: 'https://www.innerengineering.com/de/online',
    p1: 'Möchtest du mehr von Sadhgurus Weisheit und Inhalten erfahren?',
    p2: 'Bist du an weiteren kostenlosen Online-Yoga- und Meditations-Sitzungen interessiert, um dein emotionales Gleichgewicht, dein körperliches Wohlbefinden und deine geistige Gesundheit zu verbessern?',
    p3: 'Hier sind Möglichkeiten, um in Kontakt zu bleiben, wo immer du auch sein magst:',
    p4: `Abonniere den Sadhguru Deutsch Kanal auf <a target='_blank' rel='noopener noreferrer' href='https://www.youtube.com/channel/UCLXPrBVzL3sDRJ3HFDq3frw'>Youtube</a>, <a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/sadhguru.deutsch/?hl=en'>Instagram</a> oder <a target='_blank' rel='noopener noreferrer' href='https://www.facebook.com/SadhguruDeutsch/'>Facebook</a>.`,
    p5: 'Erfahre Inner Engineering mit Sadhguru in deiner eigenen Geschwindigkeit bei dir zu Hause. Inner Engineering besteht aus sieben wirkungsvollen Sitzungen, in denen kraftvolle Werkzeuge aus der uralten Wissenschaft des Yoga vermittelt werden, die die Art und Weise, wie du lebst, wie du dein Leben führst und erfährst, transformieren können.',
    p6: 'Zusätzlich kannst du die Playlist Meditation / Hatha Yoga / Upa Yoga abrufen um deine Übungen weiter zu üben.',
    p7: 'Erfahre Inner Engineering mit Sadhguru in deiner eigenen Geschwindigkeit bei dir zu Hause. Inner Engineering besteht aus sieben wirkungsvollen Sitzungen, in denen kraftvolle Werkzeuge aus der uralten Wissenschaft des Yoga vermittelt werden, die die Art und Weise, wie du lebst, wie du dein Leben führst und erfährst, transformieren können.',
    h2: 'Erhalte die monatlichen Updates über Sadhgurus und Ishas Aktivitäten in deiner Region. Melde dich unten an!',
    h3: 'Für mehr kostenlose Meditations & Yogainhalte, schau auf dem Sadhguru Deutsch Kanal',
    h4: 'Inner Engineering Online',
    form1: 'Vollständiger Name',
    form2: 'E-Mail Adresse',
    form3: 'Land',
    thanks1: 'Dankeschön',
    thanks2: 'Wir werden Ihnen in Kürze eine Bestätigungs-E-Mail schicken'
  },
  fr: {
    h1: 'Restez en contact avec Sadhguru et Isha',
    quote:
      "“Un monde plein d'amour, de lumière et de rires, son heure est venue. Faisons en sorte qu'il se réalise.” —Sadhguru",
    btn1: 'En savoir plus',
    btn2: "S'inscrire maintenant",
    btn3: 'Méditations guidées',
    btn4: 'Upa Yoga',
    link1:
      'https://www.youtube.com/playlist?list=PLqJCH3uwCKvXeQ-VQuutILnNJh_uX4YbX',
    link2:
      'https://www.youtube.com/playlist?list=PLqJCH3uwCKvXFpwsuVTlZJ_0Ez9l2WCIh',
    link3: 'https://www.innerengineering.com/fr/online',
    p1: 'Souhaitez-vous accéder à davantage de sagesse et de contenu de Sadhguru?',
    p2: "Êtes-vous intéressé par d'autres séances gratuites de yoga et de méditation en ligne pour améliorer votre équilibre émotionnel, votre bien-être physique et votre santé mentale?",
    p3: 'Voici 3 façons de rester en contact, où que vous soyez :',
    p4: `Abonnez-vous à la chaîne Sadhguru Français sur <a target='_blank' rel='noopener noreferrer' href='https://www.youtube.com/channel/UCrmjX43WdTRI8RwVuRUACCw'>youtube</a>, <a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/sadhguru.francais/?hl=en'>instagram</a> ou <a target='_blank' rel='noopener noreferrer' href='https://www.facebook.com/SadhguruFrancais/'>facebook</a>.`,
    p5: "Faites l'expérience du génie intérieur avec Sadhguru dans votre propre espace, à votre propre rythme. Inner Engineering Online est composé de sept sessions de 90 minutes qui transmettent des outils puissants issus de l'ancienne science du yoga, avec le potentiel de transformer la façon dont vous vivez, conduisez et expérimentez votre vie.",
    h2: "Recevez des mises à jour mensuelles sur les activités de Sadhguru et d'Isha dans votre région. Inscrivez-vous ci-dessous!",
    h3: 'Pour plus de pratiques gratuites de yoga et de méditation, consultez la chaîne Sadhguru Français.',
    h4: 'Ingénierie intérieure en ligne',
    form1: 'Nom complet',
    form2: 'Adresse e-mail',
    form3: 'Pays',
    thanks1: 'Merci',
    thanks2: 'Nous vous enverrons un courriel de confirmation sous peu.'
  }
};

export default text;
